import { Group, Skeleton, Stack, Text } from '@mantine/core';
import React, { useEffect, useState } from 'react';
import { getChartRiwayatCompletionMission } from '../../services/report-gamification';
import { useQuery } from '@tanstack/react-query';
import BarChart from '../../components/elements/BarChart';
import Card from '../../components/elements/Card';
import dayjs from 'dayjs';

export default function ChartRiwayatCompletionMission() {
  const [dataChart, setDataChart] = useState([]);

  const fetchedDataRiwayatCompletionMission = useQuery({
    queryKey: [`chartHistoryCompletionMission`],
    queryFn: () => getChartRiwayatCompletionMission(),
    enabled: true
  });

  const {
    data: dataCompletionMission,
    isLoading,
    isError
  } = fetchedDataRiwayatCompletionMission;

  useEffect(() => {
    if (dataChart.length === 0 && dataCompletionMission?.data?.data) {
      const _modifiedData = dataCompletionMission?.data?.data
        .sort((a, b) => a.month - b.month)
        .map((item) => {
          return {
            ...item,
            label: dayjs()
              .month(item.month - 1)
              .format('MMMM')
          };
        });
      setDataChart(_modifiedData);
    }
  }, [dataCompletionMission, dataChart]);

  const renderContent = () => (
    <BarChart
      chartKeys={['total']}
      chartLabels={['Total Completion']}
      chartColors={['#7B2183']}
      data={dataChart || []}
      loading={isLoading}
      isError={isError}
      onLoad={() => fetchedDataRiwayatCompletionMission.refetch()}
      chartLabelPosition="bottom"
      chartHeight={150}
    />
  );

  return (
    <Card flex={1} h={'100%'}>
      <Stack gap={'xs'}>
        <Group justify="space-between">
          <Text className="text-sm-semibold">Total Completion Mission</Text>
          <Text className="text-xs-medium" c="gray">
            last 6 month
          </Text>
        </Group>
        {isLoading && <Skeleton height={150} />}
        {!isLoading && renderContent()}
      </Stack>
    </Card>
  );
}
